import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { ISeoSectionData } from '@utils/contentful/getSharedPageData/getSharedPageData'
import React from 'react'

export const SeoSection = ({
  seoSectionData,
}: {
  seoSectionData: ISeoSectionData[]
}) => {
  return (
    <div
      className={`${
        seoSectionData?.length > 1 ? 'grid' : ''
      } px-8 py-6 md:gap-x-24 bg-core-grey-lightest rounded-3xl md:grid-cols-2`}
    >
      {seoSectionData?.map((seoSection, index) => {
        return (
          <div className="py-6 text-lg text-core-purple" key={index}>
            <ContentfulMarkdown overrideClass="pb-2 font-bold">
              {seoSection?.title}
            </ContentfulMarkdown>

            <ContentfulMarkdown overrideClass="text-lg">
              {seoSection?.description}
            </ContentfulMarkdown>
          </div>
        )
      })}
    </div>
  )
}
